export const isMobile = () => {
    // 先检查是否可进入移动端
    const modeFlag = localStorage.getItem('modeFlag');
    if (modeFlag && modeFlag === '0') {
        return false;
    }
    // 先检查已保存的视图模式
    const savedMode = localStorage.getItem('viewMode');
    if (savedMode) {
        return savedMode === 'mobile';
    }

    // 如果没有保存的设置，则根据设备类型判断
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = [
        'phone', 'pad', 'pod', 'iphone', 'ipod', 'ios', 'ipad',
        'android', 'mobile', 'blackberry', 'iemobile', 'mqqbrowser',
        'juc', 'fennec', 'wosbrowser', 'browserng', 'webos',
        'symbian', 'windows phone'
    ];

    return mobileKeywords.some(keyword => userAgent.includes(keyword));
}

export const setViewMode = (isMobileView) => {
    localStorage.setItem('viewMode', isMobileView ? 'mobile' : 'desktop');
    // 触发路由刷新
    window.location.reload();
}
export const setModeFlag = (role) => {
    // 移动端允许的角色列表
    const mobileRoles = ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'];
    localStorage.setItem('modeFlag', mobileRoles.includes(role) ? '1' : '0');
}

export const getViewMode = () => {
    return isMobile();
}